export default __webpack_public_path__ + "static/media/IMG_4942.ac81d3af.png";